/**
 * TikTok standard event names (aligned with Meta funnel steps in metaEventNames.js).
 *
 * Funnel step → TikTok event:
 *   Start Quiz         → ViewContent
 *   Quiz Completed     → AddToCart
 *   Payment page       → InitiateCheckout
 *   Add Payment Info   → AddPaymentInfo
 *   Add Payment Info Upsell → AddPaymentInfoUpsell
 *   First Purchase     → Subscribe
 *   Purchase           → CompletePayment
 */
export const TIKTOK_EVENT_START_QUIZ = 'ViewContent'
export const TIKTOK_EVENT_QUIZ_COMPLETED = 'AddToCart'
export const TIKTOK_EVENT_INITIATE_CHECKOUT = 'InitiateCheckout'
export const TIKTOK_EVENT_ADD_PAYMENT_INFO = 'AddPaymentInfo'
export const TIKTOK_EVENT_ADD_PAYMENT_INFO_UPSELL = 'AddPaymentInfoUpsell'
export const TIKTOK_EVENT_FIRST_PURCHASE = 'Subscribe'
export const TIKTOK_EVENT_PURCHASE = 'CompletePayment'
